import HttpService from "./htttp.service";

class ComplaintsService {
  // ComplaintsEndpoint = process.env.API_URL;

  getComplaints = async () => {
    const getComplaints = "dash/complaints";
    return await HttpService.get(getComplaints);
  };

  getComplaintsSingle = async (id) => {
    const getComplaintsSingle = `dash/complaints/${id}`;
    return await HttpService.get(getComplaintsSingle);
  };

  getComplaintsStats = async () => {
    const getComplaintsStats = "dash/complaints/stats";
    return await HttpService.get(getComplaintsStats);
  };

  getIncompleteComplaints = async () => {
    const getIncompleteComplaints = "dash/complaints/incomplete";
    return await HttpService.get(getIncompleteComplaints);
  };

  createComplaint = async (payload) => {
    const createComplaint = "dash/complaints/new";
    return await HttpService.post(createComplaint, payload);
  };

  editComplaint = async (id, payload) => {
    const editComplaint = `dash/complaints/${id}`;
    return await HttpService.put(editComplaint, payload);
  };

  editComplaintStatus = async (id, payload) => {
    const editComplaintStatus = `dash/complaints/status/${id}`;
    return await HttpService.put(editComplaintStatus, payload);
  };
}

export default new ComplaintsService();
